export default __webpack_public_path__ + "static/media/Souldrinker.b605505c.jpg";